// extracted by mini-css-extract-plugin
export default {"NotFound":"HUzDX5ET","Text":"mmMbHnIc","Buttons":"jdbe7B0t","isMobile":"uaDlWvUT"};